@let status = indicator().status;

<mat-card class="flat-card">
  @if (isStatusLoading() && overlay.editMode()) {
    <div class="loader-container">
      <app-loader containerClass="no-margin" />
    </div>
  }

  <div class="indicator-card-content">
    <div class="indicator-card-content__left">
      <span class="indicator-count">{{ position() }}</span>
      @if (
        status === indicatorStatus.RISK_ABSENT ||
        status === indicatorStatus.NOT_APPLICABLE ||
        (status === indicatorStatus.RISK_PRESENT && mitigationsCompleted())
      ) {
        <mat-icon class="indicator-icon" icon-medium-18>check</mat-icon>
      }
    </div>
    <div class="indicator-card-content__right">
      <mat-card-header>
        <mat-card-title>
          <span>{{ indicator().indicator }}</span>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <app-button-group class="indicator-actions">
          @if (indicator().guidance) {
            <app-button type="ghost" (pressed)="toggleShowGuidance()">
              @if (showGuidance()) {
                <ng-container i18n="@@ui.hideguidance">Hide guidance</ng-container>
              } @else {
                <ng-container i18n="@@ui.showguidance">Show guidance</ng-container>
              }
            </app-button>
          }
        </app-button-group>

        @if (showGuidance()) {
          <div class="guidance">
            <quill-view [content]="indicator().guidance" [class.expanded]="true" format="html" />
          </div>
        }

        @if (overlay.viewMode() && label) {
          <div class="tag-container">
            <div
              class="app-tag"
              [ngClass]="{
                RED: status === indicatorStatus.RISK_PRESENT && !mitigationsCompleted(),
                GREEN:
                  status === indicatorStatus.RISK_ABSENT ||
                  (status === indicatorStatus.RISK_PRESENT && mitigationsCompleted()),
                LIGHT_GREY: status === indicatorStatus.NOT_APPLICABLE,
              }"
            >
              {{ label }}
            </div>
          </div>
        }

        @if (overlay.editMode()) {
          <div class="radio-button-group-container">
            <app-radio-button-group>
              @for (option of statusOptions; track option.value) {
                @if (option.value) {
                  <app-radio-button
                    [checked]="status === option.value"
                    [label]="
                      option.value === indicatorStatus.RISK_PRESENT
                        ? mitigationsCompleted()
                          ? translations.riskPresentMitigated
                          : option.label
                        : option.label
                    "
                    [name]="'risk-group-' + indicator().id"
                    [value]="option.value"
                    (changeEvent)="onStatusChange(option.value)"
                  />
                  &nbsp;
                }
              }
            </app-radio-button-group>

            @if (!!status) {
              <app-button
                type="icon"
                size="medium"
                [tp]="translations.resetResponseTp"
                [tpIsLazy]="true"
                (pressed)="resetResponse.emit(indicator())"
              >
                <mat-icon icon-medium-18>replay</mat-icon>
              </app-button>
            }
          </div>
        }

        @if (status === indicatorStatus.RISK_PRESENT) {
          <div class="add-mitigation-btn-container">
            <app-form-label [label]="translations.mitigationsLabel" />

            @if (overlay.editMode()) {
              <app-button
                [disabled]="overlay.loading()"
                class="icon-add-circle"
                type="icon"
                (pressed)="openMitigationsPanel.emit()"
              >
                <mat-icon icon-medium-18>add</mat-icon>
              </app-button>
            }
          </div>
          @if (mitigations().length) {
            @for (mitigation of mitigations(); track mitigation.id) {
              <app-risk-mitigation-card
                [riskMitigation]="mitigation"
                [editMode]="overlay.editMode()"
                (statusChange)="
                  updateMitigationStatus.emit({
                    indicatorId: indicator().id,
                    mitigation: mitigation,
                    status: $event,
                  })
                "
                (remove)="
                  removeMitigation.emit({
                    indicatorId: indicator().id,
                    mitigationId: mitigation.id,
                  })
                "
              />
            }
          } @else if (overlay.viewMode()) {
            <div class="no-mitigations-placeholder">-</div>
          }
        }

        <app-rich-text-editor
          [ngClass]="{ hide: overlay.viewMode() && !noteControl().value }"
          [label]="translations.noteLabel"
          [placeholder]="translations.optionalNotePh"
          [control]="noteControl()"
          [enableViewMode]="overlay.viewMode()"
        />

        @if (overlay.editMode()) {
          <div class="save-container container-flex-right">
            <app-button
              type="ghost"
              [disabled]="noteControl().pristine"
              (pressed)="onSave()"
              i18n="@@action.save"
            >
              Save
            </app-button>
          </div>
        }
      </mat-card-content>
    </div>
  </div>
</mat-card>
